import {createApp} from "vue";
import store from './store';
import router from './router/index';
import './index.css';
import './vselect.css';
import App from "./components/App";
import axios from 'axios';
import { VueWindowSizePlugin } from 'vue-window-size/option-api';

const maxRetry = 3;
axios.interceptors.response.use(undefined, function (errorResponse) {
    if (errorResponse) {
        /** @type {import("axios").AxiosRequestConfig} */
        const originalRequest = errorResponse.config;
        if (errorResponse.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            store.dispatch('logout')
            return router.push('/login')
        }

        if (errorResponse.response.status === 500 && (originalRequest._retryCount === undefined || originalRequest._retryCount < maxRetry)) {
            originalRequest._retryCount = originalRequest._retryCount === undefined ? 1 : originalRequest._retryCount + 1;
            return axios(originalRequest);
        }
    }

    return Promise.reject(errorResponse);
})


const vuejs = createApp(App);
vuejs.use(router);
vuejs.use(store);
vuejs.use(VueWindowSizePlugin);

vuejs.config.productionTip = process.env.NODE_ENV === 'development';
vuejs.config.devtools = process.env.NODE_ENV === 'development';
vuejs.config.globalProperties.$apiUrl = process.env.VUE_APP_API_URL
vuejs.config.globalProperties.$axios = axios

if(process.env.NODE_ENV !== 'production') {
    console.log(process.env)
    console.log(vuejs.config)
}

store.commit('setApiUrl', vuejs.config.globalProperties.$apiUrl);
store.commit('setAxios', axios)

try {
    const app = vuejs.mount('#app');
} catch (e) {
    if(process.env.NODE_ENV === 'development') {
        throw e;
    }
}

// Now the app has started!

